import React, { useEffect, useState } from "react";
import { getLyrics } from "../../services/API/axios";
import "./SongLyrics.css";
import BeatLoader from "react-spinners/BeatLoader";
import logo from "../../assets/Dog-swimming.png";
import PersonIcon from "@material-ui/icons/Person";
import AlbumIcon from "@material-ui/icons/Album";
import jsPDF from "jspdf";
import GetAppIcon from "@material-ui/icons/GetApp";

function LyricsHeader({ music, lyrics }) {
  const { artist, title, albumTitle, picture } = music;

  const download = () => {
    var doc = new jsPDF("p", "pt", "a4");
    const pageHeight = doc.internal.pageSize.height;
    let y = 500;
    if (y >= pageHeight) {
      doc.addPage();
      y = 0;
    }
    doc.setFont("cursive", "bold", 600);
    doc.setFontSize(12);

    doc.text(200, 20, artist);
    doc.text(200, 40, albumTitle);
    doc.setFontSize(10);
    doc.text(20, 70, `${lyrics.lyrics.replace(/\r/g, "\r\n\n")}`);

    doc.save(`${title}.pdf`);
  };
  return (
    <>
      <div className="songlyrics__header">
        <div className="songlyrics__data">
          <img src={picture} alt="album" className="songlyrics__image" />
          <div className="songlyrics__caption">
            <span className="songlyrics__title">
              <AlbumIcon className="songlyrics__header__icon" />
              &nbsp;
              {albumTitle}
            </span>
            <span className="songlyrics__artist">
              <PersonIcon className="songlyrics__header__icon" />
              &nbsp;
              {artist}
            </span>
          </div>
        </div>
        <button onClick={download} className="songlyrics__download">
          <GetAppIcon />
        </button>
      </div>
    </>
  );
}

function SongLyrics({ music }) {
  const { artist, title, albumTitle, picture } = music;
  const [lyrics, setLyrics] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const artistTitle = `${artist}/${title}`;
    setIsLoading(true);

    async function fetchLyrics() {
      const request = await getLyrics.get(artistTitle);
      setIsLoading(false);
      setLyrics(request.data);
      return request;
    }

    fetchLyrics();
  }, [artist, title, albumTitle]);

  return (
    <div className="songlyrics">
      <LyricsHeader music={music} lyrics={lyrics} />
      <div className="songlyrics__div">
        {lyrics.lyrics && !isLoading ? (
          <>
            <pre>{lyrics.lyrics.replace(/\r/g, "\r\n\n")}</pre>
          </>
        ) : !lyrics.lyrics && !isLoading ? (
          <div className="songlyrics__error__content">
            <img src={logo} className="songlyrics__error" alt="error" />
            <p>Sorry no Lyrics Found!!!</p>
          </div>
        ) : (
          <BeatLoader loading="true" color={"#ffffff"} />
        )}
      </div>
    </div>
  );
}

export default SongLyrics;
